import _ from "lodash";
import React, { ReactElement, useState } from "react";
import { Alert, Button, Form } from "react-bootstrap";

import { UserSelect } from "../../users";
import { Lead } from "../Lead";
import { LeadService } from "../LeadService";
import { LeadStatusSelect } from "../LeadStatusSelect";

interface IProps {
	leads: Lead[];
}

export const SubmitCSV = (props: IProps): ReactElement => {
	const [userId, setUserId] = useState<number>();
	const [statusId, setStatusId] = useState<number>();
	const [source, setSource] = useState<string>("");
	const [submitted, setSubmitted] = useState<boolean>(false);

	const leadService = new LeadService();

	const handleSubmit = () => {
		if (statusId && userId) {
			leadService.upload(props.leads, statusId, userId, source);
			setSubmitted(true);
		}
	};

	return (
		<div className="container" style={{ marginBottom: 60 }}>
			<hr />
			{!submitted ? (
				<>
					<h4>Submit Uploads</h4>
					<div className="mt-4 mb-4">
						<strong>Sales Rep</strong>
						<UserSelect
							handleChange={(user: any) => {
								setUserId(user.value);
							}}
							isMulti={false}
						/>
					</div>
					<div className="mt-4 mb-4">
						<strong>Status</strong>
						<LeadStatusSelect
							handleChange={(status: any) => {
								setStatusId(status.value);
							}}
						/>
					</div>
					<div className="mt-4 mb-4">
						<strong>Source</strong>
						<Form.Control
							type="text"
							onChange={(event: any) => {
								if (event.target) {
									setSource(event.target.value);
								}
							}}
						/>
					</div>
					<div className="mt-4 mb-4">
						<Button variant="primary" onClick={handleSubmit}>
							Submit
						</Button>
					</div>
				</>
			) : (
				<Alert variant="success">
					List has been submitted for uploading
				</Alert>
			)}
		</div>
	);
};
